import React, { Component } from 'react';
import WallNavLetterTile from '../atoms/WallNavLetterTile';
import classNames from 'classnames';

class WallNavLinks extends Component {

  clickHandler = (i) => {
    this.props.setIndex(i, true);
  };

  render() {
    let classes = classNames("WallNavLinks",{ 'floor': parseInt(this.props.wall) === 9, 'wall': parseInt(this.props.wall) !== 9 });
    return (
      <ul className={classes} style={{height: this.props.height + 'px'}}>
        {this.props.locationList.map( ( location, i, arr ) => {
          let classes = classNames({ 'current': i === this.props.currentLocationIndex });
          return (
            <React.Fragment key={i}>
              <WallNavLetterTile wall={this.props.wall} location={location.node} prevLocation={arr[ i - 1 ]}/>
              <li className={classes} onClick={() => {this.clickHandler(i)}}/>
            </React.Fragment>
          )
        } )}
      </ul>
    )
  }
}

export default WallNavLinks;